import React from 'react';
import PropTypes from 'prop-types';

import { H2, H3, Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { Section, Container } from 'components/core/Page';

import iconPinBox from 'assets/images/landing/state-pages/pin&box.svg';
import iconMapPin from 'assets/images/icons/icon_map_pin.svg';
import iconUnit from 'assets/images/icons/icon_unit.svg';
import iconBox from 'assets/images/icons/icon_box.svg';
import iconMoney from 'assets/images/icons/icon_money.svg';
import iconPercentage from 'assets/images/icons/icon_percentage.svg';
import iconCoin from 'assets/images/icons/icon_coin.svg';
import iconMostPopular from 'assets/images/icons/icon_most_popular.svg';

import './StatePageFacts.scss';

export default function StatePageFacts({ state, selfStorageFacts }) {
	const icons = [
		iconMapPin,
		iconUnit,
		iconBox,
		iconMoney,
		iconPercentage,
		iconCoin,
		iconMostPopular,
	];
	return (
		<div className="state-page-facts">
			<div className="icon-container">
				<Image src={iconPinBox} />
			</div>
			<div className="facts-blue-gray-bg">
				<Container
					flush
					className="state-page-facts-container"
				>
					<div className="facts-container">
						<Section className="facts-section">
							<div>
								<Section>
									<H2
										size="medium"
										className="state-page-title"
									>
										{state} Self-Storage Facts
									</H2>
								</Section>
								<Section>
									<div
										className="facts-intro"
										// eslint-disable-next-line react/no-danger
										dangerouslySetInnerHTML={{
											__html: selfStorageFacts.copy,
										}}
									/>
								</Section>
								<Section>
									<H2
										size="medium"
										className="state-page-subtitle"
									>
										Below are some statistics that provide
										an overview of the self-storage industry
										in {state}:
									</H2>
								</Section>
								{selfStorageFacts.facts.map(
									({ fact, highlight }, index) =>
										index < 3 && (
											<Section key={fact}>
												<Image src={icons[index]} />
												<H3
													color="red"
													className="highlight"
												>
													{highlight}
												</H3>
												<Paragraph className="fact">
													{fact}
													{/* {index > 2 &&
														` ${highlight}`} */}
												</Paragraph>
											</Section>
										),
								)}
							</div>
						</Section>
					</div>
				</Container>
			</div>
		</div>
	);
}

StatePageFacts.propTypes = {
	state: PropTypes.string.isRequired,
	selfStorageFacts: PropTypes.shape({
		copy: PropTypes.string,
		facts: PropTypes.arrayOf(
			PropTypes.shape({
				fact: PropTypes.string.isRequired,
				highlight: PropTypes.string.isRequired,
			}),
		),
	}).isRequired,
};
